import { Row, Space } from "antd";
import { useState } from "react";
import ShareIcon from "../../../assets/icons/share.svg";
import ShareModalComponent from "../../../components/ShareModalComponent";
import { ILive } from "../../../helpers/types";

interface Props {
  id: string;
  live: ILive | null;
}

export const FanLiveRTMPFooter = (props: Props) => {
  const { id, live } = props;
  const [isShareModalOpen, setIsShareModalOpen] = useState<boolean>(false);

  return (
    <>
      <Space className="z-fan-live footer-shadow mb-5" direction="vertical">
        <Row className="justify-content-end flex-no-wrap gap-24" align="middle">
          <img src={ShareIcon} width={22} alt="share" onClick={() => setIsShareModalOpen(true)} />
        </Row>
      </Space>
      <ShareModalComponent
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        id={live?.creator?._id}
        username={live?.creator?.username}
        link="https://twizz.app/ifc2"
        headerTitle="share-stream-via"
      />
    </>
  );
};
